import React, { ReactNode, useState } from 'react';
import styles from './FormField.module.css';

interface FormFieldProps {
  label: string;
  required?: boolean;
  error?: string;
  helperText?: string;
  children: ReactNode;
  className?: string;
}

export const FormField: React.FC<FormFieldProps> = ({
  label,
  required = false,
  error,
  helperText,
  children,
  className = '',
}) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div className={`${styles.container} ${className}`}>
      <div className={styles.labelContainer}>
        <label className={styles.label}>
          {label}
          {required && <span className={styles.required}>*</span>}
        </label>
        {helperText && !error && (
          <div
            className={styles.tooltipIcon}
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
            title={helperText}
          >
            ?
            {showTooltip && (
              <div className={styles.tooltip}>
                {helperText}
              </div>
            )}
          </div>
        )}
      </div>
      {children}
      {error && (
        <p className={styles.error}>{error}</p>
      )}
    </div>
  );
};
